import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../../custom-hooks/useAuth';

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ minHeight: '60vh' }}
      >
        <div
          className="spinner-border text-primary mb-3"
          role="status"
          style={{ width: '3rem', height: '3rem', color: 'var(--primary-color)' }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="text-muted fw-semibold">Authenticating...</p>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
};

export default ProtectedRoute;
